export default "__VITE_ASSET__X_M1S1Vb__"